import React from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../../atoms/icons/index'

export const MobileRedirect = () => {
  return (
    <div className={s.mobilePageContainer}>
      <IconSvg.MobileRedirect />
      <h3 className={s.mobilePageTitle}>
        Accédez instantanément à vos réservations en version web
      </h3>
      <p className={s.mobilePageText}>
        Nous vous invitons à vous connecter sur Naboo via un ordinateur, merci !
      </p>
    </div>
  )
}
